<h2 mat-dialog-title>Add new item?</h2>
<mat-dialog-content>
    <p>Are you sure you want to add this new {{data.itemName}}: <strong>{{data.newItem}}</strong>.</p>
    @if (data.similarItems.length) {
    <p>There already are similar items:</p>
    <ul>
        @for(item of data.similarItems; track item) {
        <li>{{item}}</li>
        }
    </ul>
    }
</mat-dialog-content>
<mat-dialog-actions>
    <button matButton mat-dialog-close>Cancel</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button matButton [mat-dialog-close]="true">Confirm</button>
</mat-dialog-actions>